<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="代理商名称" :value="1"></el-option>
                            <el-option label="代理商ID" :value="2"></el-option>
                            <el-option label="合同编号" :value="3"></el-option>
                            <el-option label="账户名" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sortType" placeholder="请选择" size="small">
                        <el-option label="优先展示最新更新的" :value="1"></el-option>
                        <el-option label="优先展示合同最早到期的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="合同到期时间" :value="1"></el-option>
                                <el-option label="最新更新时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            align="right"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/agent/edit')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" size="small" @click="add()">创建代理商</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="代理商名称" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column label="演出数量" prop="activityNum">
                    <template slot-scope="{row} = scope">
                        <el-link v-if="row.activityNum > 0" :href="`/activityManage/activity/list?btype=11&bvalue=${row.id}`" target="_blank">{{row.activityNum}}</el-link>
                        <span v-else>0</span>
                    </template>
                </el-table-column>
                <el-table-column prop="contractSn" label="合同编号" min-width="150"></el-table-column>
                <el-table-column prop="contractExpireTime" label="合同到期时间" min-width="160"></el-table-column>
                <el-table-column prop="modifyTime" label="最新更新时间" min-width="160"></el-table-column>
                <el-table-column prop="principleName" label="代理商负责人" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="modifyUser" label="最后修改人" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/agent/edit')" type="text" size="small" @click="edit(row.id)" >编辑</el-button>
                        <el-button v-if="$utils.have('/agent/log')" type="text" size="small" @click="log(row.id)" >修改日志</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    searchType: 1, //查询类型 1：演出名称 2：演出id
    searchValue: "",
    endTime: "",
    beginTime: "",
    timeType: 1,
    sortType: 1
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                timeType: parseInt(this.$route.query.timeType || 1),
                sortType: parseInt(this.$route.query.sortType || 1),
            },
            listLoading: true,
            datetimerange: [this.$route.query.beginTime || '' , this.$route.query.endTime || ''],
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                beginTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/agent/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add(){
            this.$router.push('/finance/agent/manage/add')
        },
        edit(id){
            this.$router.push({
                path: `/finance/agent/manage/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        log(id){
            this.$router.push({
                path: `/finance/agent/manage/log/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
    }
}
</script>

<style lang="scss" scoped>

</style>